define('responsive-game-feed/app/scripts/views/PlayByPlay',['require','exports','module','../utils/Tracking','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','../utils/Utils','gameday-language/gameday-language','gameday-language/translator','gameday-resource-path/gameday-resource-path'],function(require, exports, module) {

    'use strict';
    
    var tracking = require("../utils/Tracking");
    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var Utils = require("../utils/Utils");
    var gamedayLanguage = require("gameday-language/gameday-language");
    var translator = require("gameday-language/translator");
    var resourcePath = require("gameday-resource-path/gameday-resource-path");
    var retina = window.devicePixelRatio > 1;
    var defaultPlayerImg = (retina) ? "http://ui.bamstatic.com/clubs/mlb/images/player-default@2x.jpg" : "http://ui.bamstatic.com/clubs/mlb/images/player-default.jpg";
    
    /**
     * CLASS DESCRIPTION
     *
     * @param NAME {TYPE} PARAM DESCRIPTION
     * @return {TYPE} RETURN DESCRIPTION
     */
    function PlaybyplayView(cfg) {
       var lang = Utils.options.language;
       this.element = cfg.element;
       this.model;
       this.lang = lang;
       this.decode = translator(lang,true);
       this.dictionary = gamedayLanguage(lang);
       this.imageFilePath;
    }

    PlaybyplayView.prototype = {
   
        render: function(cfg) {
               var that = this;
               var template = hogan.compile(cfg.template); 
               var model = cfg.model;
               var playerid;
               this.model = model;
              
               
               if (this.lang === 'es') {
                 this.model.data.description = model.data.description_es;
                 this.model.data.result = model.data.result_es;
                 
                 if (this.model.data.description_tracking_es) {
                    this.model.data.description_tracking = model.data.description_tracking_es;
                 }
                 
               }
               
               if (!this.imageFilePath){
                 this.imageFilePath = (window.devicePixelRatio > 1) ? "@2x" : "";
               }
               
               this.model.data.defaultPlayerImg = defaultPlayerImg;
               this.model.data.playerImgPath = resourcePath.get("mugshot",{pid : model.data.player_id});
               
               
               var html = template.render({model : model, mustacheLanguage : this.dictionary});
               var imgTag;
               Utils.insertItem(this.element,model,html);

               var currentElement = $("#" + model.guid);
               var playerMug = $("#"+ model.guid + " .player-mug");
               
               
               if( typeof model.data.score !== "undefined" ) {
		         currentElement.addClass("has-score");
	           }
	           
	           if (model.data.description_tracking) {
	              currentElement.addClass("has-tracking");  
	           }
	           
	           playerid = model.data.player_id;
               
               if( typeof playerid !== "undefined"  && playerid != 0) {
                 playerMug.on("click", function(e) {
                   Utils.sendPlayerMessage.call(this, {target: $(this), event:e});
                 });
               }
                              
               $(cfg.feedView).trigger("renderCBTracker_"+cfg.model.guid, cfg.model.guid);
			   
			   
        }
       
   };    

    return PlaybyplayView;

});
